import { Div } from '@kizi/core-components';
import styled from '@emotion/styled';

export const NoScrollbarContainer = styled(Div)`
  max-height: 100vh;
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
